/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M6.25 2.027c2.343 0 4.25 1.843 4.25 4.11 0 .682-.173 1.326-.479 1.893l2.616 2.53L20.497 3 22 4.453 10.164 15.837a3.97 3.97 0 0 1 .335 1.6c0 2.267-1.906 4.11-4.25 4.11S2 19.704 2 17.437s1.906-4.109 4.25-4.109c.982 0 1.888.324 2.609.867l2.272-2.186-2.533-2.448a4.329 4.329 0 0 1-2.348.685C3.906 10.246 2 8.403 2 6.136 2 3.87 3.906 2.028 6.25 2.028zm9.25 11.301 6.5 6.22L20.498 21l-6.5-6.22zm-9.25 2.055c-1.172 0-2.125.922-2.125 2.055s.953 2.055 2.125 2.055 2.125-.922 2.125-2.055-.953-2.055-2.125-2.055zm0-11.301c-1.172 0-2.125.921-2.125 2.055 0 1.133.953 2.054 2.125 2.054s2.125-.921 2.125-2.054c0-1.134-.953-2.055-2.125-2.055z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCut as Cut };
